import { useState } from "react";
import type { MpzpCoverageLegendItem, MpzpSelectionRule } from "../../types";
import { MpzpCoverageBadge } from "./MpzpCoverageBadge";

/**
 * Zwijany opis metodologii preselektu — „Dlaczego te działki są zaznaczone?".
 *
 * Treść reguł przychodzi z backendu (mpzp/constants.py), a nie jest przepisana tutaj:
 * gdyby front miał własną kopię, opis i faktyczne zachowanie systemu rozjechałyby się
 * przy pierwszej zmianie reguły — a to jest ekran, na podstawie którego ktoś decyduje,
 * czy zaufać zaznaczeniu.
 */
export function MpzpSelectionRulesPanel({
  rules,
  legend,
}: {
  rules: MpzpSelectionRule[];
  legend: MpzpCoverageLegendItem[];
}) {
  const [open, setOpen] = useState(false);
  if (!rules.length) return null;

  return (
    <div className="border border-[var(--color-border)] bg-[var(--color-bg-elevated)]">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-3 py-2 text-left text-sm font-medium hover:bg-[var(--color-bg-hover)]"
      >
        <span>Dlaczego te działki są zaznaczone?</span>
        <span className="text-[var(--color-text-muted)] font-mono text-xs">
          {open ? "zwiń ▲" : "rozwiń ▼"}
        </span>
      </button>

      {open && (
        <div className="px-3 pb-3 space-y-4 text-sm">
          <div className="space-y-3">
            {rules.map((rule) => (
              <div key={rule.key} className="border-l-2 border-[var(--color-border-strong)] pl-3">
                <div className="font-medium">{rule.title}</div>
                <p className="text-[var(--color-text-muted)] mt-0.5">{rule.detail}</p>
                <p className="text-[11px] text-[var(--color-text-muted)] mt-1 font-mono">
                  Źródło: {rule.source}
                </p>
              </div>
            ))}
          </div>

          <div>
            <div className="font-medium mb-2">Znaczniki pokrycia planem</div>
            <div className="space-y-1.5">
              {legend.map((item) => (
                <div key={item.key} className="flex items-start gap-2">
                  <MpzpCoverageBadge status={item.key} />
                  <span className="text-[var(--color-text-muted)]">{item.detail}</span>
                </div>
              ))}
            </div>
          </div>

          <p className="text-[var(--color-text-muted)] border-t border-[var(--color-border)] pt-2">
            Zaznaczenie to propozycja, nie decyzja — możesz odznaczyć dowolną działkę i dodać
            dowolną inną, także taką bez pokrycia planem (gmina wyda wtedy zaświadczenie o jego
            braku).
          </p>
        </div>
      )}
    </div>
  );
}
